<template>
    <div class="row justify-content-center">
        <div class="col-md-12  grid-margin stretch-card">
            <div class="card">
                <div class="card-body">
                    <div class="profile-card 4">
                        <div class="row align-items-center">
                            <!-- <div class="col-12 col-lg-3 text-center">
                                <path-image class="profile-img img-fluid"
                                    :path_image="info?.path_image ?? `/img/icons/member.png`" />
                                <h2 class="mt-3"> {{ info?.name }}</h2>

                            </div> -->
                            <div class="col-12 col-lg-3">
                                <div class="card-img qr-code">
                                    <path-image class="profile-img fit-cover img-fluid"
                                        :path_image="info?.path_image ?? `${info?.gender == 0 ? 'female.png' : 'male.png'}`" />
                                    <!-- <path-image class="img-fluid"
                                        :path_image="`storage/qrcodes/${info?.matricule}.jpeg` ?? `/img/icons/member.png`" /> -->
                                    <p class="mt-2 mb-0 text-muted  "> <b>
                                            {{ info?.name }}
                                        </b> </p>

                                    <p>

                                        <span :class="imageStatus.cssClass">
                                            {{ imageStatus.message }}
                                        </span>
                                    </p>
                                </div>
                            </div>

                            <div class="col-12 col-lg-6">
                                <ul class="contact-info list-unstyled">
                                    <li v-if="info?.matricule" class=" ">
                                        <p class="timeline-content d-flex"><b class="d-inline-block w-160">{{
                                            i18n.t('tables.members.matricule') }}
                                            </b>:
                                            <font-awesome-icon style="margin: 0px 5px;" icon="eye" size="lg"
                                                class="link-icon" />
                                            <member-route :memberUUID="info?.uuid" :matricule="info?.matricule" />
                                        </p>
                                    </li>
                                    <li v-if="hasPermission('download_contract') && info?.contractNumber" class=" ">
                                        <p class="timeline-content d-flex"><b class="d-inline-block w-160">{{
                                            i18n.t('tables.members.contractNumber') }}
                                            </b>:

                                            {{
                                                activeSubscription?.contractNumber
                                            ?? info?.contractNumber
                                            ?? ''
                                            }}
                                            
                                        </p>
                                    </li>
                                    <li v-if="info?.gender !== null && info?.gender !== undefined" class="">
                                        <p class="timeline-content d-flex">
                                            <b class="d-inline-block w-160">
                                                {{ i18n.t('tables.members.gender') }}
                                            </b>:
                                            <span>
                                                {{genders.find(g => g.id === Number(info.gender))?.name}}

                                                <b>({{ i18n.t("tables.target_age." + info?.age_category) }})</b>
                                            </span>
                                        </p>
                                    </li>
                                    <li v-if="info?.name" class=" ">
                                        <p class="timeline-content d-flex"><b class="d-inline-block w-160">{{
                                            i18n.t('tables.members.name') }}
                                            </b>:
                                            {{ info?.name }} </p>
                                    </li>
                                    <li v-if="info?.parent_name" class=" ">
                                        <p class="timeline-content d-flex"><b class="d-inline-block w-160">{{
                                            i18n.t('tables.members.parent_name') }}
                                            </b>:
                                            {{ info?.parent_name }} </p>
                                    </li>

                                    <li v-if="info?.cin" class=" ">
                                        <p class="timeline-content d-flex"><b class="d-inline-block w-160">{{
                                            i18n.t('tables.members.cin') }}
                                            </b>:
                                            {{ info?.cin }} </p>
                                    </li>
                                    <li v-if="info?.occupation" class=" ">
                                        <p class="timeline-content d-flex"><b class="d-inline-block w-160">{{
                                            i18n.t('tables.members.occupation') }}
                                            </b>:
                                            {{ info?.occupation }} </p>
                                    </li>
                                    <li v-if="info?.dateBirth" class=" ">
                                        <p class="timeline-content d-flex"><b class="d-inline-block w-160">{{
                                            i18n.t('tables.members.dateBirth') }}
                                            </b>:
                                            {{ formatDate(info?.dateBirth) }} </p>
                                    </li>
                                    <li v-if="info?.dateBirth" class=" ">
                                        <p class="timeline-content d-flex"><b class="d-inline-block w-160">{{
                                            i18n.t('tables.members.age') }}
                                            </b>:
                                            {{ calculateAge(info?.dateBirth) }} </p>
                                    </li>


                                    <li v-if="info?.email" class=" ">
                                        <p class="timeline-content d-flex"><b class="d-inline-block w-160">{{
                                            i18n.t('tables.members.email') }}
                                            </b>:
                                            {{ info?.email }} </p>
                                    </li>
                                    <li v-if="info?.tele" class=" ">
                                        <p class="timeline-content d-flex"><b class="d-inline-block w-160">{{
                                            i18n.t('tables.members.tele') }}
                                            </b>:
                                            {{ info?.tele }} </p>
                                    </li>


                                    <li v-if="info?.adresse" class=" ">
                                        <p class="timeline-content d-flex"><b class="d-inline-block w-160">{{
                                            i18n.t('tables.members.adresse') }}
                                            </b>:
                                            {{ info?.adresse }} </p>
                                    </li>
                                    <li v-if="info?.comment" class=" ">
                                        <p class="timeline-content d-flex"><b class="d-inline-block w-160">{{
                                            i18n.t('tables.members.comment') }}
                                            </b>:
                                            {{ info?.comment }} </p>
                                    </li>
                                    <li v-if="info?.seller?.name" class=" ">
                                        <p class="timeline-content d-flex"><b class="d-inline-block w-160">{{
                                            i18n.t('tables.members.last_seller') }}
                                            </b>:
                                            <font-awesome-icon style="margin: 0px 5px;" icon="eye" size="lg"
                                                class="link-icon" />
                                            <span class="cursor-pointer"
                                                @click="redirectTo({ name: 'fiche-trainer', params: { trainerID: info?.seller?.id, clubUUID: clubUUID } })">
                                                {{ info?.seller?.name }}
                                            </span>
                                        </p>
                                    </li>
                                    <li v-if="info?.parent_name" class=" ">
                                        <p class="timeline-content d-flex"><b class="d-inline-block w-160">{{
                                            i18n.t('status.attached_to') }}
                                            </b>:
                                            {{ info?.parent_name }} </p>
                                    </li>

                                    <li v-if="info?.sync_image_to_pointeuse !== undefined" class="">
                                        <p class="timeline-content d-flex align-items-center">
                                            <b class="d-inline-block w-160">
                                                {{ i18n.t('tables.members.sync_image') }}
                                            </b> :

                                          {{
                                                info.sync_image_to_pointeuse
                                            ? "Autorisé (Par l'adhérent)"
                                            : "Non autorisé (Par l'adhérent)"
                                            }}
                                        </p>
                                    </li>

                                </ul>
                            </div>

                            <div class="col-12 col-lg-3  position-relative">
                                <loader-gif v-if="isRequestPDF" />
                                <div class="card-img qr-code" ref="qrList">

                                    <qrcode-vue class="profile-img  img-fluid" :value="`${info?.matricule}`"
                                        :size="150" />
                                    <!-- <path-image class="profile-img  img-fluid"
                                        :path_image="`storage/qrcodes/${info?.matricule}.jpeg` ?? `/img/icons/member.png`" /> -->
                                    <div class="mt-2 mb-0 text-muted small cursor-pointer" @click="exportToPdf">
                                        {{ i18n.t('button.download', { title: '' }) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isBtn" class="row mt-5">
                            <div v-if="hasPermission('edit_member')" class="col-6">
                                <div class="form-group ">
                                    <button @click="openModal('modal_edit_member', 'edit', null)" type="button"
                                        class="w-100 btn btn-edit ">
                                        <font-awesome-icon icon="edit" size="lg" class="link-icon mr-2" />
                                        {{ i18n.t('button.edit') }}</button>
                                </div>
                            </div>
                            <div v-if="hasPermission('fiche_inscription')" class="col-6">
                                <div class="form-group ">
                                    <button @click="ficheInscription(info, activeSubscription)" type="button"
                                        class="w-100 btn btn-file ">
                                        <font-awesome-icon icon="file" size="lg" class="link-icon mr-2" />{{
                                            i18n.t('views.clients.member_fiche.fiche_pdf.title') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script setup>
import { useModal } from '@/composables/modal/useModal';
import { usePDF } from '@/composables/global/usePDF';
import { useGlobal } from "@/composables/global/useGlobal";
import {  clubUUID, genders } from '@/shared/state';
import { usePermission } from "@/composables/auth/usePermission";
import { useMembersPDF } from "@/composables/pdf/useMembersPDF";
import { useLabel } from "@/composables/global/useLabel"; // Dir l'chemin s7iḥ
import { defineProps, toRefs, ref, computed } from 'vue';
import i18n from "@/i18n/index"

import QrcodeVue from 'qrcode.vue'


const props = defineProps({
    info: Object,
    isBtn: Boolean,
    activeSubscription: Object
});

let { info, isBtn, activeSubscription } = toRefs(props);
const { redirectTo, printOrSaveToPdf, calculateAge, formatDate } = useGlobal();

const { openModal } = useModal();
const { validerImage } = useLabel();

const { ficheInscription } = usePDF();

const { hasPermission } = usePermission();


// Export QR codes to PDF
const { exportMembersBadgePDF, isRequestPDF } = useMembersPDF();
const qrList = ref(null); // Reference to the QR code container
const exportToPdf = async () => {

    if (!qrList.value) {
        console.error("QR list container is not available");
        return;
    }


    const swalOption = {
        title: i18n.t('message.confirmation.export.invoice.title'),
        denyButtonText: i18n.t('message.confirmation.export.invoice.button.print'),
        cancelButtonText: i18n.t('button.cancel'),
        confirmButtonText: i18n.t('message.confirmation.export.invoice.button.pdf'),
    }
    const exportedType = await printOrSaveToPdf(swalOption)
    if (exportedType !== 'cancel') {

        exportMembersBadgePDF([info.value], qrList.value.querySelectorAll('canvas'), exportedType)
    }

};

const imageStatus = computed(() => validerImage(info.value.path_image));

</script>

<style scoped>
h2 {
    font-size: 15px;
}



.profile-img.fit-cover {
    object-fit: cover;
}

.profile-img {

    width: 150px;
    height: 150px;
}

.card-img.qr-code {
    background: #f8f9fa;
}

.card-img {
    padding: 15px;
    border-radius: 15px;
    text-align: center;
}

.card-img img {
    max-width: 150px;
    margin: 0 auto;
}

.contact-info li {
    padding: 8px 0;
    border-bottom: 1px solid #eee;
}

.contact-info li:last-child {
    border-bottom: none;
}

@media (max-width: 768px) {
    .profile-img {
        margin-top: 20px;
        width: 120px;
        height: 120px;
    }

    .card-img {
        margin-top: 20px;
    }
}
</style>